import { RangeAddress } from 'shared/excel/rangeAddress';


export class RangeProxy {
  _range = null;
  worksheet = null;

  static PropsToLoad = {
    Range: ['rowIndex', 'columnIndex', 'rowCount', 'columnCount', 'address'],
    Worksheet: ['id', 'name'],
  };

  get impl() { return this._range; }
  get rowIndex() { return this.rangeAddress.rowIndex; }
  get columnIndex() { return this.rangeAddress.columnIndex; }
  get rowCount() { return this.rangeAddress.rowCount; }
  get columnCount() { return this.rangeAddress.columnCount; }
  get address() { return this.rangeAddress.address; }

  static wrap(rangeImpl) {
    const proxy = new RangeProxy(rangeImpl.worksheet);
    proxy.rangeAddress = new RangeAddress(rangeImpl.address);
    proxy._range = rangeImpl;
    return proxy;
  }

  static async loadAndWrap(rangeImpl) {
    rangeImpl.load(RangeProxy.PropsToLoad.Range);
    rangeImpl.worksheet.load(RangeProxy.PropsToLoad.Worksheet);
    await rangeImpl.context.sync();
    return RangeProxy.wrap(rangeImpl);
  }

  static async loadMultipleRangeProxies(rangeImpls) {
    rangeImpls.forEach(rangeImpl => {
      rangeImpl.load(RangeProxy.PropsToLoad.Range);
      rangeImpl.worksheet.load(RangeProxy.PropsToLoad.Worksheet);
    });

    await rangeImpls[0].context.sync();

    return rangeImpls.map(rangeImpl => RangeProxy.wrap(rangeImpl));
  }

  static fromRangeAddress(worksheet, rangeAddress) {
    const proxy = new RangeProxy(worksheet);
    proxy.rangeAddress = rangeAddress instanceof RangeAddress ? rangeAddress : new RangeAddress(rangeAddress);
    const { rowIndex, columnIndex, rowCount, columnCount } = proxy.rangeAddress;
    proxy._range = worksheet.getRangeByIndexes(rowIndex, columnIndex, rowCount, columnCount);
    return proxy;
  }

  constructor(worksheet) {
    this.worksheet = worksheet;
  }

  getRow(index) {
    return this.getRows(index, 1);
  }

  getRows(index, count) {
    return this._makeCopy(this.rangeAddress.getRows(index, count));
  }

  getLastRow() {
    return this._makeCopy(this.rangeAddress.getLastRow());
  }
  
  getColumn(index) {
    return this.getColumns(index, 1);
  }
  
  getColumns(index, count) {
    return this._makeCopy(this.rangeAddress.getColumns(index, count))
  }

  getLastColumn() {
    return this._makeCopy(this.rangeAddress.getLastColumn());
  }

  getOffsetAndResizedRange(deltas = {}, options = {}) {
    return this._makeCopy(this.rangeAddress.getOffsetAndResizedRange(deltas, options));
  }

  _makeCopy(rangeAddress) {
    return RangeProxy.fromRangeAddress(this.worksheet, rangeAddress);
  }
}

export default RangeProxy;